import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import api from '../../utils/api';
import { useAuth } from '../../context/AuthContext';

const ROLES = [
  { id:'seller', icon:'🧑‍🌾', title:'Farmer / Seller', desc:'I grow crops and want to sell them directly to buyers' },
  { id:'buyer',  icon:'🛒',    title:'Buyer',           desc:'I want to buy fresh crops directly from farmers' },
  { id:'agent',  icon:'🤝',    title:'Agent',           desc:'I connect farmers with buyers and manage listings' },
];

export default function SelectRolePage() {
  const [selected, setSelected] = useState('');
  const [loading, setLoading]   = useState(false);
  const { updateUser }          = useAuth();
  const navigate                = useNavigate();

  const handleSelect = async () => {
    if (!selected) return toast.error('Please select a role');
    setLoading(true);
    try {
      const { data } = await api.post('/auth/select-role', { role: selected });
      updateUser({ role: data.user.role });
      toast.success('Role selected!');
      navigate('/complete-profile');
    } catch (err) { toast.error(err.response?.data?.message || 'Error'); }
    finally { setLoading(false); }
  };

  return (
    <div className="auth-screen">
      <div className="auth-logo">
        <div className="auth-logo__icon">👋</div>
        <h1 className="auth-logo__title">Welcome!</h1>
        <p className="auth-logo__tagline">How will you use ZevaZeva?</p>
      </div>
      <div className="auth-card" style={{ width:'100%', maxWidth:420 }}>
        <div className="form-group" style={{ gap:'var(--sp-3)', marginBottom:'var(--sp-5)' }}>
          {ROLES.map(r => (
            <div key={r.id} className={`role-card${selected === r.id ? ' role-card--active' : ''}`} onClick={() => setSelected(r.id)}>
              <span className="role-card__icon">{r.icon}</span>
              <div>
                <div className="role-card__title">{r.title}</div>
                <div className="role-card__desc">{r.desc}</div>
              </div>
            </div>
          ))}
        </div>
        <button className="btn btn--primary btn--lg" onClick={handleSelect} disabled={!selected || loading}>
          {loading ? <span className="spinner spinner--sm spinner--white" /> : 'Continue →'}
        </button>
      </div>
    </div>
  );
}
